import moment from "moment";

const initialState = {
    user: {},
    menuItems: [],
    menuItemsShortcuts: [],
    agents: [],
    agentsOfDealer: [],
    dealers: [],
    rights: [],
    accountConfig: {
        persistListDates: false,
        startDate: "",
        endDate: ""
    }
};

export const SET_USER = "USER_OPTIONS/SET_USER";
export const SET_MENU_ITEMS = "USER_OPTIONS/SET_MENU_ITEMS";
export const SET_MENU_ITEMS_SHORTCUTS = "USER_OPTIONS/SET_MENU_ITEMS_SHORTCUTS";
export const SET_RIGHTS = "USER_OPTIONS/SET_RIGHTS";
export const SET_AGENTS = "USER_OPTIONS/SET_AGENTS";
export const SET_AGENTS_OF_DEALER = "USER_OPTIONS/SET_AGENTS_OF_DEALER";
export const SET_DEALERS = "USER_OPTIONS/SET_DEALERS";
export const SET_START_DATE = "USER_OPTIONS/ACCOUNT_CONFIG/SET_START_DATE";
export const SET_END_DATE = "USER_OPTIONS/ACCOUNT_CONFIG/SET_END_DATE";
export const SET_DATES = "USER_OPTIONS/ACCOUNT_CONFIG/SET_DATES";
export const SET_PERSIST_LIST_DATES = "USER_OPTIONS/ACCOUNT_CONFIG/SET_PERSIST_LIST_DATES";
export const PURGE = "USER_OPTIONS/PURGE";

export const setUser = user => ({
    type: SET_USER,
    user
});

export const setMenuItems = menuItems => ({
    type: SET_MENU_ITEMS,
    menuItems
})
export const setMenuItemsShortcuts = menuItemsShortcuts => ({
    type: SET_MENU_ITEMS_SHORTCUTS,
    menuItemsShortcuts
})

export const setRights = rights => ({
    type: SET_RIGHTS,
    rights
})

export const setAgents = agents => ({
    type: SET_AGENTS,
    agents
})

export const setAgentsOfDealer = agentsOfDealer => ({
    type: SET_AGENTS_OF_DEALER,
    agentsOfDealer
})

export const setDealers = dealers => ({
    type: SET_DEALERS,
    dealers
})

export const setStartDate = date => ({
    type: SET_START_DATE,
    date
})

export const setEndDate = date => ({
    type: SET_END_DATE,
    date
})

export const purge = () => ({
    type: PURGE
})

export const setPersistDates = persistDates => ({
    type: SET_PERSIST_LIST_DATES,
    persistDates
})

export const setDates = () => ({
    type: SET_DATES
})

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_USER: {
            return {
                ...state,
                user: action.user
            }
        }

        case SET_MENU_ITEMS: {
            return {
                ...state,
                menuItems: action.menuItems
            }
        }

        case SET_MENU_ITEMS_SHORTCUTS: {
            return {
                ...state,
                menuItemsShortcuts: action.menuItemsShortcuts
            }
        }

        case SET_RIGHTS: {
            return {
                ...state,
                rights: action.rights
            }
        }

        case SET_AGENTS: {
            return {
                ...state,
                agents: action.agents
            }
        }

        case SET_AGENTS_OF_DEALER: {
            return {
                ...state,
                agentsOfDealer: action.agentsOfDealer
            }
        }

        case SET_DEALERS: {
            return {
                ...state,
                dealers: action.dealers
            }
        }

        case SET_START_DATE: {
            return {
                ...state,
                accountConfig: {
                    ...state.accountConfig,
                    startDate: action.date
                }
            }
        }

        case SET_END_DATE: {
            return {
                ...state,
                accountConfig: {
                    ...state.accountConfig,
                    endDate: action.date
                }
            }
        }

        case PURGE: {
            return {
                ...initialState
            }
        }

        case SET_PERSIST_LIST_DATES: {
            return {
                ...state,
                accountConfig: {
                    ...state.accountConfig,
                    persistListDates: action.persistDates
                }
            }
        }

        case SET_DATES: {
            if (state.persistDates) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    accountConfig: {
                        ...state.accountConfig,
                        startDate: moment().format("YYYY-MM-DD"),
                        endDate: moment().format("YYYY-MM-DD")
                    }
                }
            }
        }
        default:
            return state;
    }
}